import { useEffect } from 'react'

import mixpanel from 'mixpanel-browser'

import { Dropdown } from '../../Dropdown/Dropdown'
import { IChatNotification } from '../types'

import { ChatNotificationItem } from './ChatNotificationItem'
import { LoadMore, NoChats } from './styles'

interface IChatnotificationsProps {
  display: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper notifications type
  notifications: any
  menuToggle: (v: boolean) => void
  loadMore: (pageNumber: number) => void
}

export const ChatNotifications = ({
  display,
  notifications,
  menuToggle,
  loadMore,
}: IChatnotificationsProps) => {
  useEffect(() => {
    if (display) {
      mixpanel.track('Show All Chats')
    }
  }, [display])
  if (!notifications.data) {
    return <></>
  }

  return (
    <Dropdown display={display} setDisplay={menuToggle}>
      {notifications.data.map(
        (notification: IChatNotification, index: number) => (
          <ChatNotificationItem
            notification={notification}
            lastItem={index === notifications.data.length - 1}
            key={Math.random()}
          />
        ),
      )}
      {notifications.has_next && (
        <LoadMore>
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => loadMore(notifications.next_page)}
          >
            Load More
          </span>
        </LoadMore>
      )}
      {!notifications.data.length && <NoChats>No chats!</NoChats>}
    </Dropdown>
  )
}
